// CustomElement[metadata] -> Controller
// Controller[metadata] -> ControllerMetadata (events, host, root)
// Scope[metadata] -> true if global scope
export const metadata = Symbol();
